<template>
  <v-card
    class="nearby-schools rounded-xl"
    elevation="8"
    :loading="schoolsLoading"
  >
    <v-list two-line>
      <v-subheader>Szkoły w okolicy {{ city }}</v-subheader>
      <v-list-item v-for="school in schools" :key="school.id">
        <v-list-item-avatar>
          <v-img :src="school.id"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title v-text="school.name"></v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <v-card-actions>
      <v-btn rounded block color="secondary" dark @click="loadMoreSchools()"
        >Pełna lista</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { schoolsCollection } from "../plugins/firebase";
//import { auth } from '@/plugins/firebase'

export default {
  name: "NearbySchools",
  props: {
    city: {
      type: String,
      required: true,
    },
    voivodeship: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      schools: [],
      schoolsLoading: true,
    };
  },
  created() {
    // Ładowanie szkół
    schoolsCollection
      .where("voivodeship", "==", this.voivodeship)
      .where("city", "==", this.city)
      .orderBy("name", "asc")
      .get()
      .then((doc) => {
        this.schools = [];
        doc.forEach((elem) => {
          const data = {
            uid: elem.id,
            name: elem.data().name,
          };
          this.schools.push(data);
        });
        this.schoolLoading = false;
      });
  },
  methods: {
    loadMoreSchools() {
      console.log("Dodaj to!");
    },
  },
};
</script>